import { tosApi } from './tosApi';

interface IDashboardAccessResponse {
  access: boolean;
  dashboard_url?: string;
  message?: string;
}

export const dashboardApi = tosApi.injectEndpoints({
  endpoints: (builder) => ({
    checkDashboardAccess: builder.query<IDashboardAccessResponse, void>({
      query: () => ({
        url: '/core/dashboard/check-access',
        method: 'GET',
      }),
    }),
  }),
});

export const { useCheckDashboardAccessQuery } = dashboardApi;
